import { render, staticRenderFns } from "./ProcessFBMReportTableMobile.vue?vue&type=template&id=4505b73e&scoped=true"
import script from "./ProcessFBMReportTableMobile.vue?vue&type=script&lang=js"
export * from "./ProcessFBMReportTableMobile.vue?vue&type=script&lang=js"
import style0 from "./ProcessFBMReportTableMobile.vue?vue&type=style&index=0&id=4505b73e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4505b73e",
  null
  
)

export default component.exports